export default __webpack_public_path__ + "static/media/whatsapp.ab1d72fa.svg";